import posthog from "posthog-js";

export function identifyPostHogUser(user: User | null | undefined) {
  if (!user?.id) return;

  posthog.identify(user.id, {
    email: user.email,
    name: user.fullname,
    role: user.role?.title,
  });

  const org = user.organization;
  if (org?.id) {
    posthog.group("organisation", org.id, {
      name: org.name,
      plan_name: org.billing_subscription?.plan_name,
    });
  }
}
